import axios from "axios";
import {getUserToken} from "../../../../../utils/functions/userToken";
import {apiUrlActiveMultipliers} from "./apiUrlActiveMultipliers";

export const getMultipliersDetails = async (id_account, platform, multipliers) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.get(
            `${apiUrlActiveMultipliers[platform][multipliers]}${id_account}/`,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch campaign details";
        return { success: false, error: errorMessage };
    }
};

export const getFilters = async (id_account) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.get(
            `${apiUrlActiveMultipliers['filters']}${id_account}/`,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch campaign details";
        return { success: false, error: errorMessage };
    }
};
